import React from 'react';

const JS_2016 = () => {
  return (
    <div >
      <h1>JS_2016</h1>
      <p>Placeholder component for: "JS 2016"</p>
    </div>
  );
};

export default JS_2016;
